var map = {
	"./arrows/bottom.svg": 103,
	"./arrows/left.svg": 104,
	"./arrows/right.svg": 105,
	"./arrows/top.svg": 106,
	"./bg.svg": 107,
	"./close.svg": 108,
	"./contacts/telegram.svg": 109,
	"./contacts/whats-app.svg": 110,
	"./lines.svg": 111,
	"./logo.svg": 112,
	"./pattern.svg": 113,
	"./success.svg": 114,
	"./top-bg.svg": 115,
	"./triangle.svg": 116,
	"./upload.svg": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 102;